import React from "react";
import { ContentSection, ButtonRenderProps } from "sprint-common-web";

import {
    ensureSubtitleFileRecordDetails,
    isFileRecordDetailsEditable
} from "../../../../../../common/file-record-details/FileRecordDetails";
import { SubtitleFileRecordLanguagesView } from "../../../../../../common/file-record-details/languages/SubtitleFileRecordLanguagesView";
import { useFileRecordDetailsState } from "../../../../hooks/useFileRecordDetailsState";
import {
    EditDynamicSubtitleButtonAside,
    EditDynamicSubtitleButtonAsideProps
} from "../edit/dynamic-subtitle/EditDynamicSubtitleButtonAside";

interface SubtitleFileRecordLanguagesSectionProps {
    height: number;
}

export const SubtitleFileRecordLanguagesSection = ({
    height
}: SubtitleFileRecordLanguagesSectionProps): JSX.Element => {
    const { fileRecordDetails, isLoading } = useFileRecordDetailsState();

    ensureSubtitleFileRecordDetails(fileRecordDetails);

    const editSubtitleButtonAside: ButtonRenderProps<EditDynamicSubtitleButtonAsideProps> = {
        fileRecordId: fileRecordDetails.id,
        isLabeled: true,
        isDisabled: !isFileRecordDetailsEditable(fileRecordDetails),
        render: EditDynamicSubtitleButtonAside
    };

    const buttons = [editSubtitleButtonAside];

    return (
        <ContentSection header="Languages" isLoading={isLoading} testId="languages-content-section" buttons={buttons}>
            <SubtitleFileRecordLanguagesView fileRecordDetails={fileRecordDetails} height={height} />
        </ContentSection>
    );
};
